import React, { useState, useEffect } from "react";
// import "../verifymail.css"
import "../../../GlobalCss/SPF/verifymail.css";
import { Link } from "react-router-dom";
import { Button, Image, Input, message } from "antd";
import { ArrowRightOutlined, ArrowLeftOutlined } from "@ant-design/icons";
import Cookies from "js-cookie";
import axios from "axios";
import { routes } from "../../../Utils/Utils";


const resetPassword = ({ history }) => {
  const [email, setEmail] = useState("");
  const [inputFocused, setInputFocused] = useState(false);
  const [buttonHovered, setButtonHovered] = useState(false);
 const tenantName = Cookies.get("tenant_name")
  const url =  `/${tenantName}`
  const handleInputChange = (e) => {
    setEmail(e.target.value);
  };
  const handleSendOTP = async () => {
    
    if (!email) {
      message.error("Please enter your email address.");
      return;
    }
  
    
    try{
        const Response = await axios.post(`${process.env.REACT_APP_BASE_URL}Auth/reset/send-otp`,
            email,
            {
              headers: { "Content-Type": "application/json" }, // Ensure correct header
            }
        );
        if(Response !=null){
          if(Response.data.statusCode == 200){
            message.success(Response.data.message);
            Cookies.set("email", email);
            history.replace("/verifyotp");
          }
          else{
            message.error(Response.data.message);
          }
        }
      }
      catch(error){
        console.error("Error sending OTP:", error);
      };
  };
  

  const handleInputFocus = () => {
    setInputFocused(true);
  };

  const handleInputBlur = () => {
    setInputFocused(false);
  };

  return (
    <>
      <div style={{ height: "100%", width: "100%" }}>
        <div className="signin-screen">
          <div className="signin-image">
            <Image
              src="/Images/illus3.png"
              style={{
                border: "none",
                width: "90%",
                height: "100%",
              }}
              showPreviewIcon={false}
              preview={false}
            />
          </div>
          <div className="signin-col">
            <div className="card-border">
              <h2>Reset Password</h2>
              <p>Please type your email address </p>
              <div style={{ display: "flex", flexDirection: "row" }}>
                <Input
                 type="email"
                  placeholder="Enter your Email"
                  value={email}
                  onChange={handleInputChange}
                  onFocus={handleInputFocus}
                  onBlur={handleInputBlur}
                  // disabled={email && !inputFocused}
                  style={{
                    backgroundColor:
                      inputFocused || email ? "#F0F5FF" : "white",
                    color: inputFocused || email ? "black" : "#ccc",
                  }}
                />
                <Button
                  style={{
                    backgroundColor:
                      email || buttonHovered ? "white" : "#D9D9D9",
                    color: email || buttonHovered ? "#3B52DF" : "white",
                    border:
                      email || buttonHovered
                        ? "1px solid #3B52DF"
                        : "1px solid #D9D9D9",
                  }}
                  disabled={!email}
                  onClick={handleSendOTP}
                >
                  Send OTP <ArrowRightOutlined />
                </Button>
              </div>
              {/* <h4>
                <Link to="/">
                  <ArrowLeftOutlined /> Edit email address
                </Link>
              </h4> */}

            </div>
          </div>
        </div>
 
      </div>
    </>
  );
};

export default resetPassword;
